import { Badge } from 'reactstrap'
import StringUtil from 'utils/string-util'

const AbsoluteValue = (text) => (
  text
    ? StringUtil.currencyCase(text)
    : <Badge color={ 'danger' }>{ '-' }</Badge>
)

const PercentageValue = (text) => (
  text
    ? `${StringUtil.transformToPercentage(text)}%`
    : <Badge color={ 'danger' }>{ '-' }</Badge>
)

const PaymentMethodDataFormatter = {
  AbsoluteValue   : AbsoluteValue,
  PercentageValue : PercentageValue
}

export default PaymentMethodDataFormatter
